export default __webpack_public_path__ + "static/GRID22-map-disasters-es-5bde7541ece42489d9b1c3be91bd436f.png";